import { render, staticRenderFns } from "./TableAulasTurma.vue?vue&type=template&id=75f9c778&scoped=true"
import script from "./TableAulasTurma.vue?vue&type=script&lang=js"
export * from "./TableAulasTurma.vue?vue&type=script&lang=js"
import style0 from "./TableAulasTurma.vue?vue&type=style&index=0&id=75f9c778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f9c778",
  null
  
)

export default component.exports